import React, { useEffect } from "react";

import { useQzTrayCertificate } from "../../../hooks/qztray/useQzTrayCertificate";
import ActionButton from "../../Buttons/ActionButton";

const QzTrayCertificateInformation: React.FC = () => {
  const { certificates, fetchCertificates, downloadCertificate, isSubmitting } =
    useQzTrayCertificate();

  useEffect(() => {
    fetchCertificates();
  }, []);

  const publicCertificate = certificates.find(
    (certificate) => certificate.type === "CERTIFICATE"
  );

  const privateKey = certificates.find(
    (certificate) => certificate.type === "PRIVATE_KEY"
  );

  const isReady = Boolean(publicCertificate && privateKey);

  return (
    <section className="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="border-b border-stroke px-6 py-5 dark:border-strokedark">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-xl font-semibold text-black dark:text-white">
              Información del Certificado
            </h2>

            <p className="mt-1 text-sm text-bodydark2">
              Estado e información del certificado digital utilizado por QZ Tray.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <span
              className={`rounded-full px-4 py-1 text-sm font-medium ${
                isReady
                  ? "bg-success/10 text-success"
                  : "bg-warning/10 text-warning"
              }`}
            >
              {isReady ? "Listo" : "Incompleto"}
            </span>

            <ActionButton
              label="Descargar certificado"
              variant="primary"
              size="sm"
              fullWidth={false}
              disabled={!publicCertificate || isSubmitting}
              onClick={() => downloadCertificate("CERTIFICATE")}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 p-6 md:grid-cols-2 xl:grid-cols-3">
        <InfoItem label="Certificado público" value={publicCertificate?.fileName || "—"} />
        <InfoItem label="Llave privada" value={privateKey?.fileName || "—"} />
        <InfoItem label="Estado" value={isReady ? "Certificado y llave disponibles" : "Faltan archivos"} />
        <InfoItem label="Algoritmo" value="RSA 2048" />
        <InfoItem label="Firma" value="SHA256withRSA" />
        <InfoItem label="Expiración" value={publicCertificate?.expirationDate || "—"} />
        <InfoItem label="Ruta certificado" value={publicCertificate?.filePath || "—"} />
        <InfoItem label="Ruta llave privada" value={privateKey?.filePath || "—"} />
        <InfoItem label="Última actualización" value={publicCertificate?.updatedAt || "—"} />
      </div>
    </section>
  );
};

interface InfoItemProps {
  label: string;
  value: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => (
  <div className="rounded-lg border border-stroke p-4 dark:border-strokedark">
    <p className="mb-1 text-xs font-medium uppercase tracking-wide text-bodydark2">
      {label}
    </p>

    <p className="break-all text-sm font-medium text-black dark:text-white">
      {value}
    </p>
  </div>
);

export default QzTrayCertificateInformation;